import { Controller } from "@hotwired/stimulus"
import { CountUp } from 'countup.js'

export default class extends Controller {
  static targets = ['counter']

  connect() {
    let counterElt = this.counterTarget;
    // Get the current width before changing display property
    const currentWidth = counterElt.offsetWidth;
    counterElt.style.width = `${currentWidth}px`;
    counterElt.style.display = 'inline-block';
    
    let targetValue = parseInt(counterElt.innerHTML.replace(/,/g, ''), 10);
    let animator = new CountUp(counterElt, targetValue, {
      startVal: targetValue - 100000,
      smartEasingThreshold: 1000,
      smartEasingAmount: 1000,
      useEasing: true
    });
    animator.start();
  }
}

